// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionA5_comp__hrDgQ"};